import React from 'react';
import Styled from 'styled';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import time from 'four-nets/icons/svg/icon_time.svg';
import photo from 'four-nets/icons/svg/icon_photo-outlined.svg';
import Options from 'four-nets/photoblog/create-post/visibility-select/options';
import Select from 'four-nets/ui-v2/form/select/select';

import { AlbumBadgesFragment } from './album-badges.graphql';
import lockIconStyles from './album-badges-lockicon.scss';
import photoIconStyles from './album-badges-photoicon.scss';
import defaultStyles from './album-badges.scss';


export interface Props extends AlbumBadgesFragment {
    children: any;
    styles: typeof defaultStyles;
    field: {
        onChange: (e: React.ChangeEvent<any>) => void;
        onBlur: (e: any) => void;
        value: any;
        name: string;
    };
}

class AlbumBadges extends React.PureComponent<Props> {
    render() {
        const styles = this.props.styles!;
        const { field, ...albumBadges } = this.props;

        return (
            <div className={styles.wrapper}>
                <div className={styles.widthWrapper}>{this.props.children}</div>
                <div className={styles.mainRow}>
                    <div className={styles.row}>
                        <div className={styles.badge}>
                            <SVGIcon style={{image: photoIconStyles.photoIcon}}  src={photo} />
                            {albumBadges.imagesCount}
                        </div>
                        <div className={styles.badge}>
                            <SVGIcon style={{image: photoIconStyles.photoIcon}}  src={time} />
                            <FormattedDateAgoView value={new Date(albumBadges.createdTime)} />
                        </div>
                    </div>
                    <Options value={field.value}>
                        {(options, src) => (
                            <Select
                                style={{
                                    icon: styles.icon,
                                    element: styles.element,
                                    container: styles.container,
                                    select: styles.select,
                                }}
                                beforeElement={<SVGIcon style={{image: lockIconStyles.lockIcon}}  src={src} />}
                                name={field.name}
                                value={field.value}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                multiple={false}
                            >
                                {options}
                            </Select>
                        )}
                    </Options>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(AlbumBadges);
